<template>
  <router-view />
</template>

<script>
export default {
  name: "app-parent"
};
</script>

<style lang="scss" scoped></style>
